const ToolboxInfo = {
  maxInstances: {
    controls_whileUntil_colour_var_internal: 1,
    controls_if_colour_var_internal: 1,
    character_motion_move: 1,
    character_motion_turn_right: 1,
    colour_picker_internal: 2,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "controls_whileUntil_colour_var_internal",
          },
          {
            kind: "block",
            type: "controls_if_colour_var_internal",
          },
          {
            kind: "block",
            type: "character_motion_move",
          },
          {
            kind: "block",
            type: "character_motion_turn_right",
          },
          {
            kind: "block",
            type: "colour_picker_internal",
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
